<template>
  <div class="common">
    <search-form
    :formConfig="formConfig"
    :source="searchData"
    @handleSearchSigner="handleSearchSigner"
    @search="search"
    >
    </search-form>

    <div class="table-common">
      <a-table
        size="middle"
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
        :row-key="(record,index) => record.id+'_'+index"
        @change="handleTableChange"
        bordered
        :locale="{emptyText: '暂无数据'}"
      >
        <template slot="signTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
        <template slot="platformUserNm" slot-scope="text, record">
            <span v-if="+record.lawTxtType === 16">
                {{record.platformUserNm}}
            </span>
            <template v-else>
                <span>{{ record.buyerUserNm }}</span>
                <span v-if="record.buyerUserNm && (record.sellerUserMn || record.fctrNm)">、</span>
                <span>{{ record.sellerUserMn }}</span>
                <span v-if="record.sellerUserMn && record.fctrNm">、</span>
                <span>{{ record.fctrNm }}</span>
            </template>
        </template>
        <template slot="artcTtl" slot-scope="text">《{{text}}》</template>
        <template slot="signStCd" slot-scope="text">{{text | signStCdTrans}}</template>
        <template slot="operation" slot-scope="text, record">
          <a v-if="record.signStCd==1" @click="download(record)">下载</a>
          <a-button
          v-if="+record.signStCd===0"
          :disabled="(+record.lawTxtType ===7 || +record.lawTxtType ===11 || +record.lawTxtType ===22 || +record.lawTxtType ===10)"
          @click="toSign(record)"
          class="btn-blue-line"
         >去签署</a-button>
        </template>
      </a-table>
      <div :class="{'table-total':pagination.total>0,'table-total-none':pagination.total==0}">
        共有记录：
        <span class="text-color-blue">{{pagination.total}} 条</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters,mapMutations} from "vuex"
import { getSignatoryByCondition,pagingLawTxtList } from "@/api/lawTxt.js"
import {getDic} from "@/api/dic.js"
export default {
    props:{
        tabType:{
            type: [String],
            required: false,
            default: function () {
                return ""; //所属tab的分类
            }
        },
        status:{
            type: [String],
            required: false,
            default: function () {
                return "";
            }
        },
    },
    name: "legaltexts-main",
    components:{

    },
    data() {
        return {
            searchData:{
                signDate:[],
                textType:"",
                signer:"",
                signStCd:""
            },
            formConfig:[
                {
                    prop: "signDate",
                    type: "dateRange",
                    label: "签署日期",
                },
                {
                    prop: "textType",
                    type: "select",
                    label: "文本类型",
                    option: [],
                    defaultProps: {
                        value: "dctVal",
                        label: "dctValNm"
                    }
                },
                {
                    prop: "signer",
                    type: "selectSearch",
                    label: "签署方",
                    option: [],
                    searchSource: true,
                    valuePorp: "userNum",
                    labelPorp: "userNm",
                    normal:true,
                    searchHandle: "handleSearchSigner"
                },
                {
                    prop: "signStCd",
                    type: "select",
                    label: "签署状态",
                    hide:this.tabType != "legaltextsAll",
                    option: [
                        { key: '0', text: '待签署' },
                        { key: '1', text: '已签署' }
                    ],
                    defaultProps: {
                        value: "key",
                        label: "text"
                    }
                }
            ],
            columns: [
                {
                    title:"签署日期",
                    sorter: true,
                    width:"100px",
                    dataIndex: "signTime",
                    scopedSlots: { customRender: "signTime" },
                },
                {
                    title:"签署方	",
                    dataIndex: "platformUserNm",
                    scopedSlots: { customRender: "platformUserNm" },
                },
                {
                    title:"文本类型	",
                    dataIndex: "artcTtl",
                    scopedSlots: { customRender: "artcTtl" }
                },
                {
                    title: "文本编号",
                    dataIndex: "bizId"
                },
                {
                    title: "签署状态",
                    dataIndex: "signStCd",
                    width:"100px",
                    hide:this.tabType != "legaltextsAll",
                    scopedSlots: { customRender: "signStCd" }
                },
                {
                    title: "操作",
                    dataIndex: "operation",
                    scopedSlots: { customRender: "operation" },
                }
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "signTime",
                sortOrder: "descend",
                total: 0,
                showSizeChanger:true,
                showQuickJumper:true,
                pageSizeOptions:['5','10', '20', '50','100'],
                showTotal:(total)=>{
                return `共 ${total} 条`
                }
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys:[],
            checkLoad:false,
            checkLoadCancel:false,
            modalShow:false,
            modalData:{},
            modalTitle:"融资复核-同意"

        };
    },
    computed: {

    },
    methods: {
        getDic(){
            getDic({
                dctTpCd:"ArtcTpcd"
            })
            .then(res => {
                const index = this.formConfig.findIndex(item => item.prop == "textType");
                this.formConfig[index].option = res.data;
            })
            .catch(err => {
                console.log(err);
            })
        },
        handleSearchSigner(value,data,cfg){
            let param = {
                queryType:0
            };
            this.getDataList(value,param,cfg);
        },
        getDataList(value,param={},cfg) { //下拉筛选
            getSignatoryByCondition({
                cstNm:value
            }).then((res) => {
                const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
                if(res.data && res.data.grid){
                    this.formConfig[index].option = res.data.grid.list||[];
                }else{
                    this.formConfig[index].option = []
                }
            })
            .catch((error)=>{
                 console.log(error);
            });
        },
        search(data) {
            console.log(data)
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData(){
            this.loading = true;
            const params = {
                signDateOrder:this.pagination.sortOrder == "ascend" ? "asc" : "desc",
                lawTxtType: this.searchData.textType,
                signBgdt: this.searchData.signDate[0],
                signExdt: this.searchData.signDate[1],
                signer: this.searchData.signer && this.searchData.signer.key,
                signStCd: this.searchData.signStCd || this.status,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
            };
            pagingLawTxtList(params)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total;
                this.tableData = res.data.grid.list;
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                sortField: sorter.field,
                sortOrder: sorter.order,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        download(item) {
            if (!item.fileId) {
                this.$message.error("下载失败，法律文本编号为空！");
                return;
            }
            const url = `/user/lawTxt/download/${item.fileId}`;
            this.axios({
                type:'post',
                url: url,
                responseType: 'blob',
                success:(res)=>{
                    // console.log(res)
                    this.utils.fileDownload(res, `${item.artcTtl}.pdf`);
                },
                fail:(res)=>{
                    this.utils.fileDownload(res, `${item.artcTtl}.pdf`);
                },
            })
        },
        toSign(data){
            this.$router.push({
                name:"inquiry/legaltexts-sign",
                params:{data:data}
            })
        },
        refresh(){
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.getTableData();
        }
    },
    created() {
        this.formConfig = this.formConfig.filter(i => !i.hide);
        this.columns = this.columns.filter(i => !i.hide);
        this.getTableData();
        this.getDic();
    },
    mounted() {},
    activated() {},
};
</script>
<style scoped>
    .input-content>div{
        margin:10px 20px 20px 0;
    }
    .common /deep/ .search-item-lable {
        min-width: 85px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/inquiry/legaltexts-main.vue